import { render, staticRenderFns } from "./GTextForm.vue?vue&type=template&id=7221c0a4&"
import script from "./GTextForm.vue?vue&type=script&lang=ts&"
export * from "./GTextForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports